// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as BlacklistPartnerRepoManager from "../repo/BlacklistPartnerRepoManager.bs.js";

var BlacklistPartnerRepo = BlacklistPartnerRepoManager.getRepo(undefined);

function blacklistPartner(payload, onSuccess, onFailure, country) {
  Curry._2(BlacklistPartnerRepo.blacklistPartner, payload, country).then(function (result) {
        if (result.TAG === /* Ok */0) {
          Curry._1(onSuccess, result._0);
        } else {
          Curry._1(onFailure, result._0);
        }
        return Promise.resolve(undefined);
      });
  
}

function whitelistPartner(payload, onSuccess, onFailure, country) {
  Curry._2(BlacklistPartnerRepo.whitelistPartner, payload, country).then(function (result) {
        if (result.TAG === /* Ok */0) {
          Curry._1(onSuccess, result._0);
        } else {
          Curry._1(onFailure, result._0);
        }
        return Promise.resolve(undefined);
      });
  
}

export {
  BlacklistPartnerRepo ,
  blacklistPartner ,
  whitelistPartner ,
  
}
/* BlacklistPartnerRepo Not a pure module */
